import React from "react";
import Select from "react-select";
import { Text } from "@mantine/core";
// import { postShop, postShopToFigure } from "../helpers/queries";
// import { useMutation, useQueryClient } from "react-query";

function ShopSearch({
  data,
  polygonRefs,
  shopList,
  map,
  selectedFloor,
  setSelectedFloor,
  drawnItems,
  setDrawnItems,
  setActiveShop,
  setActiveFloors,
  activeShop,
}) {
  const findShop = (e) => {
    if (e === null) {
      setActiveFloors([]);
    } else {
      const shopsFound = [];
      const floorsFound = [];
      const keys = Object.entries(polygonRefs.current);
      keys.forEach((key) => {
        if (e.id === key[1]?.options.children.props.item.shop_id) {
          shopsFound.push(key[0]);
          polygonRefs.current[key[0]].openPopup();
          // console.log("shopsFound", shopsFound);
        }
      });

      // if (shopsFound.length === 0) {
      data.forEach((floor) => {
        floor.map_settings.coordinates?.forEach((shop) => {
          if (e.id === shop.shop_id) {
            floorsFound.push(floor);
            // console.log("floorsFound :>> ", floorsFound);
          }
        });
      });
      // }
      setActiveFloors(floorsFound);

      if (floorsFound.length !== 0) {
        setSelectedFloor(floorsFound[0]);
        setDrawnItems(
          floorsFound[0].map_settings.coordinates !== null
            ? floorsFound[0].map_settings.coordinates
            : []
        );

        setActiveShop(e);
      }
    }
  };

  return (
    window.appSettings?.search !== "false" && (
      <>
        {window.appSettings?.frontend !== "true" && 
          <div className="cc-select-label">
            <Text size="xs">Meklēt</Text>
          </div> 
        }
        
        <Select
          className="cc-select"
          onChange={(e, triggeredAction) => {
            findShop(e);
            if (triggeredAction.action === "clear") {
              setActiveShop(null);
            }
          }}
          isClearable
          getOptionLabel={(option) => option.title}
          getOptionValue={(option) => option.id}
          options={shopList}
          defaultValue={activeShop}
          placeholder={"Ievadiet veikala nosaukumu"}
        />
        {activeShop !== null && (
          <Text
            weight="500"
            className="cc-search-text"
            size="lg"
            align="center"
          >
            {`Meklēšana pēc vārda: ${activeShop.title}`}
          </Text>
        )}
      </>
    )
  );
}

export default ShopSearch;
